import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const UnsavedTranscriptChanges = ({
  hasGeneratedAudio,
  onCancel,
  onClose
}) => {
  return /*#__PURE__*/_jsx(ConfirmModal, {
    use: "default",
    width: 500,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `audioNarration.${hasGeneratedAudio ? 'unsavedAudio' : 'unsavedChanges'}.message`
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `audioNarration.${hasGeneratedAudio ? 'unsavedAudio' : 'unsavedChanges'}.description`
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "audioNarration.unsavedChanges.confirmLabel"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "audioNarration.unsavedChanges.rejectLabel"
    }),
    onConfirm: onClose,
    onReject: onCancel
  });
};
export default UnsavedTranscriptChanges;